/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	DepartmentDTO,
	DepartmentDTOFromJSON,
	DepartmentDTOFromJSONTyped,
	DepartmentDTOToJSON,
} from "./DepartmentDTO";
import {
	FacultyDTO,
	FacultyDTOFromJSON,
	FacultyDTOFromJSONTyped,
	FacultyDTOToJSON,
} from "./FacultyDTO";
import { Role, RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from "./Role";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";
import {
	StudyProgramDTO,
	StudyProgramDTOFromJSON,
	StudyProgramDTOFromJSONTyped,
	StudyProgramDTOToJSON,
} from "./StudyProgramDTO";

/**
 *
 * @export
 * @interface AnnouncementDTO
 */
export interface AnnouncementDTO {
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementDTO
	 */
	title?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementDTO
	 */
	description?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof AnnouncementDTO
	 */
	validFrom?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof AnnouncementDTO
	 */
	validTo?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementDTO
	 */
	publisherName?: string | null;
	/**
	 *
	 * @type {Role}
	 * @memberof AnnouncementDTO
	 */
	recipientRole?: Role;
	/**
	 *
	 * @type {Array<StudentYearEnum>}
	 * @memberof AnnouncementDTO
	 */
	years?: Array<StudentYearEnum> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AnnouncementDTO
	 */
	studyCycles?: Array<string> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AnnouncementDTO
	 */
	targetCompanyIds?: Array<string> | null;
	/**
	 *
	 * @type {Array<FacultyDTO>}
	 * @memberof AnnouncementDTO
	 */
	faculties?: Array<FacultyDTO> | null;
	/**
	 *
	 * @type {Array<DepartmentDTO>}
	 * @memberof AnnouncementDTO
	 */
	departments?: Array<DepartmentDTO> | null;
	/**
	 *
	 * @type {Array<StudyProgramDTO>}
	 * @memberof AnnouncementDTO
	 */
	studyPrograms?: Array<StudyProgramDTO> | null;
}

export function AnnouncementDTOFromJSON(json: any): AnnouncementDTO {
	return AnnouncementDTOFromJSONTyped(json, false);
}

export function AnnouncementDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AnnouncementDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		title: !exists(json, "title") ? undefined : json["title"],
		description: !exists(json, "description") ? undefined : json["description"],
		validFrom: !exists(json, "validFrom")
			? undefined
			: new Date(json["validFrom"]),
		validTo: !exists(json, "validTo") ? undefined : new Date(json["validTo"]),
		publisherName: !exists(json, "publisherName")
			? undefined
			: json["publisherName"],
		recipientRole: !exists(json, "recipientRole")
			? undefined
			: RoleFromJSON(json["recipientRole"]),
		years: !exists(json, "years")
			? undefined
			: json["years"] === null
			? null
			: (json["years"] as Array<any>).map(StudentYearEnumFromJSON),
		studyCycles: !exists(json, "studyCycles") ? undefined : json["studyCycles"],
		targetCompanyIds: !exists(json, "targetCompanyIds")
			? undefined
			: json["targetCompanyIds"],
		faculties: !exists(json, "faculties")
			? undefined
			: json["faculties"] === null
			? null
			: (json["faculties"] as Array<any>).map(FacultyDTOFromJSON),
		departments: !exists(json, "departments")
			? undefined
			: json["departments"] === null
			? null
			: (json["departments"] as Array<any>).map(DepartmentDTOFromJSON),
		studyPrograms: !exists(json, "studyPrograms")
			? undefined
			: json["studyPrograms"] === null
			? null
			: (json["studyPrograms"] as Array<any>).map(StudyProgramDTOFromJSON),
	};
}

export function AnnouncementDTOToJSON(value?: AnnouncementDTO | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		title: value.title,
		description: value.description,
		validFrom:
			value.validFrom === undefined ? undefined : value.validFrom.toISOString(),
		validTo:
			value.validTo === undefined ? undefined : value.validTo.toISOString(),
		publisherName: value.publisherName,
		recipientRole: RoleToJSON(value.recipientRole),
		years:
			value.years === undefined
				? undefined
				: value.years === null
				? null
				: (value.years as Array<any>).map(StudentYearEnumToJSON),
		studyCycles: value.studyCycles,
		targetCompanyIds: value.targetCompanyIds,
		faculties:
			value.faculties === undefined
				? undefined
				: value.faculties === null
				? null
				: (value.faculties as Array<any>).map(FacultyDTOToJSON),
		departments:
			value.departments === undefined
				? undefined
				: value.departments === null
				? null
				: (value.departments as Array<any>).map(DepartmentDTOToJSON),
		studyPrograms:
			value.studyPrograms === undefined
				? undefined
				: value.studyPrograms === null
				? null
				: (value.studyPrograms as Array<any>).map(StudyProgramDTOToJSON),
	};
}
